import { useState } from 'react'
import { Dialog } from 'radix-ui'
import { Combobox } from '@/components/common/Combobox'
import { usePartyRoles, useAddParty } from '../../parties/hooks'

export function AddPartyDialog({ contractId, onClose }: {
  contractId: number
  onClose: () => void
}) {
  const roles = usePartyRoles()
  const add = useAddParty(contractId)
  const [roleCode, setRoleCode] = useState('')
  const [customerId, setCustomerId] = useState<number | ''>('')
  const [error, setError] = useState<string | null>(null)

  const submit = () => {
    setError(null)
    if (!roleCode || !customerId) {
      setError('Wybierz rolę i klienta.')
      return
    }
    add.mutate(
      { customerId: Number(customerId), roleCode },
      { onSuccess: onClose, onError: () => setError('Nie udało się dodać osoby.') },
    )
  }

  return (
    <Dialog.Root open onOpenChange={o => { if (!o) onClose() }}>
      <Dialog.Portal>
        <Dialog.Overlay className="fixed inset-0 z-50 bg-black/40" />
        <Dialog.Content className="fixed left-1/2 top-1/2 z-50 -translate-x-1/2 -translate-y-1/2 bg-white rounded-lg p-5 w-[420px] shadow-xl">
          <Dialog.Title className="text-base font-semibold">Dodaj osobę do umowy</Dialog.Title>
          <div className="mt-4 flex flex-col gap-3 text-sm">
            <label className="grid gap-1">
              <span className="text-xs uppercase text-slate-500">Rola</span>
              <Combobox<string>
                value={roleCode || null}
                onChange={v => setRoleCode(v ?? '')}
                options={(roles.data ?? []).map(r => ({ value: r.code, label: r.labelPl }))}
                emptyOptionLabel="- wybierz -"
                placeholder="Wybierz rolę..."
              />
            </label>
            <label className="grid gap-1">
              <span className="text-xs uppercase text-slate-500">ID klienta</span>
              <input
                type="number"
                value={customerId}
                onChange={e => setCustomerId(e.target.value === '' ? '' : Number(e.target.value))}
                className="border rounded px-2 py-1"
              />
            </label>
            {error && <p className="text-xs text-red-600">{error}</p>}
            <div className="flex justify-end gap-2 mt-2">
              <button onClick={onClose} className="px-3 py-1 text-sm border rounded">Anuluj</button>
              <button
                onClick={submit}
                disabled={add.isPending}
                className="px-3 py-1 text-sm bg-sky-600 text-white rounded disabled:opacity-50"
              >
                Dodaj
              </button>
            </div>
          </div>
        </Dialog.Content>
      </Dialog.Portal>
    </Dialog.Root>
  )
}
